export default __webpack_public_path__ + "static/media/house-2.b9c7ffeb.jpg";